document.addEventListener('DOMContentLoaded', () => {
  //BSS-custom: change this variable for custom submit button
  const customLabel = "S'inscrire"
  //


    
  const intervalID = setInterval(() => {
    const submitBtn = document.querySelector('.bss-b2b-rf-submit-button input[type="submit"]')
    if(submitBtn) {
      submitBtn.value = customLabel
    }
    if (submitBtn && submitBtn.value == customLabel) {
      clearInterval(intervalID)
    }
  }, 200)
})